const KNOWLEDGE_BASE_ENDPOINT = '/knowledge-base';

export const KnowledgeBaseRoutes = {
  getAll: () => `${KNOWLEDGE_BASE_ENDPOINT}`,
  getMenu: () => `${KNOWLEDGE_BASE_ENDPOINT}/menu`,
  getOne: (id: string) => `${KNOWLEDGE_BASE_ENDPOINT}/${id}`,
  getIdFromSlug: (slug: string) => `${KNOWLEDGE_BASE_ENDPOINT}/id-from-slug/${slug}`,
};
